import {
  spreedlyDefaultSchema,
  spreedlyToastSchema,
} from './forms/spreedly-form.schema';

export const getSchema = formName => {
  switch (formName) {
    case 'spreedly':
    case 'spreedly_condenced_enhanced':
      return spreedlyDefaultSchema;
    case 'toast_spreedly':
    case 'spreedly_enhanced':
    case 'toast_spreedly_canada':
    case 'spreedly_canada_enhanced':
      return spreedlyToastSchema;
    default:
      throw new Error('Spreedly Configuration Error - Unknown Form Name');
  }
};
